export class MeasureRecord {
    id: number;
    shiftBlockId: number;
    shiftRecordId?: number;
    workflowTimeFacility: string;
    measureId: number;
    amount: number;
    modifiedByUserName: string;
    modifiedDate: Date;
}
